export { CorporativoLanding } from "./CorporativoLanding";
